/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S6_P3Inputs */

const en_guide_json_vs_yaml_xml_s6_p3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When in doubt, optimize for the reader who will be confused at 2am during an incident. Clear structure in a format their tools already understand beats a clever choice that saves a few characters.`)
};

const ko_guide_json_vs_yaml_xml_s6_p3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`고민된다면 새벽 2시 장애 상황에서 헷갈릴 사람을 기준으로 최적화하세요. 몇 글자 아끼는 영리한 선택보다, 그 사람의 도구가 이미 이해하는 형식의 명확한 구조가 낫습니다.`)
};

const ja_guide_json_vs_yaml_xml_s6_p3 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S6_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`迷ったら、深夜二時の障害対応で混乱する人を基準に最適化しましょう。数文字を節約する賢い選択よりも、その人のツールがすでに理解している形式の明確な構造のほうが勝ります。`)
};

/**
* | output |
* | --- |
* | "When in doubt, optimize for the reader who will be confused at 2am during an incident. Clear structure in a format their tools already understand beats a cle..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S6_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s6_p3 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S6_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S6_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s6_p3(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s6_p3(inputs)
	return ja_guide_json_vs_yaml_xml_s6_p3(inputs)
});